import { render, staticRenderFns } from "./OrderLogin.vue?vue&type=template&id=019faae5&lang=pug&"
import script from "./OrderLogin.vue?vue&type=script&lang=js&"
export * from "./OrderLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports